import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=b570e220&scoped=true&"
import script from "./JsonEditor.vue?vue&type=script&lang=js&"
export * from "./JsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./Styles/json-editor.scss?vue&type=style&index=0&id=b570e220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b570e220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b570e220')) {
      api.createRecord('b570e220', component.options)
    } else {
      api.reload('b570e220', component.options)
    }
    module.hot.accept("./JsonEditor.vue?vue&type=template&id=b570e220&scoped=true&", function () {
      api.rerender('b570e220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/JsonEditor.vue"
export default component.exports